module.exports = __webpack_public_path__ + "img/photo03_sp.71743889.jpg";